import { connection } from '../../utils/connection';
import { AUTH_URL } from '../../config/config';

async function fetchUsersService({ token }) {
    return await connection({ method: 'GET', url: `${AUTH_URL.FETCH_USERS}`, extraHeaders: { token: token } });
}

export default fetchUsersService;
